var _path, _path2, _path3, _path4;

const _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconGoogle(_ref, svgRef) {
  let {
    title,
    titleId
  } = _ref,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 22 22",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.5005 11.2332C21.5005 10.3699 21.4291 9.7399 21.2744 9.0865H11.2148V12.9832H17.1196C17.0006 13.9515 16.3577 15.4099 14.9291 16.3898L14.9091 16.5203L18.0897 18.935L18.3101 18.9565C20.3338 17.1249 21.5005 14.4298 21.5005 11.2332Z",
    fill: "#4285F4"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.214 21.5C14.1068 21.5 16.5362 20.5664 18.3101 18.9565L14.9291 16.3898C14.0244 17.0082 12.8092 17.4399 11.214 17.4399C8.38069 17.4399 5.97596 15.6083 5.11874 13.0766L4.99309 13.0871L1.68583 15.5954L1.64258 15.7132C3.40446 19.1433 7.0235 21.5 11.214 21.5Z",
    fill: "#34A853"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M5.12095 13.0767C4.89476 12.4233 4.76386 11.7233 4.76386 11C4.76386 10.2766 4.89476 9.5766 5.10905 8.92331L5.10306 8.78417L1.75435 6.23553L1.64478 6.28661C0.918623 7.70996 0.501953 9.3083 0.501953 11C0.501953 12.6916 0.918623 14.2899 1.64478 15.7133L5.12095 13.0767Z",
    fill: "#FBBC05"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M11.2141 4.55997C13.2259 4.55997 14.583 5.41163 15.3569 6.12335L18.3807 3.23C16.5236 1.53834 14.1069 0.5 11.2141 0.5C7.02353 0.5 3.40447 2.85665 1.64258 6.28662L5.10686 8.92332C5.97598 6.39166 8.38073 4.55997 11.2141 4.55997Z",
    fill: "#EB4335"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconGoogle);
export default __webpack_public_path__ + "static/media/icon_google.e0360b0d677bcd6a301e222ff9049f76.svg";
export { ForwardRef as ReactComponent };